<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'workflow.title'"></app-header-bar>
  </div>
  <div class="content mt-2 mb-3">
    <div class="row">
      <app-datatable
        [dataSource]="source"
        [columns]="columns"
        [identifier]="'workflows'"
        [actionNew]="canWriteWorkflows"
        [iconActions]="iconActions"
        (showEvent)="canWriteWorkflows && show($event.valueOf())"
        (newEvent)="new()"
      >
        <app-empty-table
          [icon]="'rebase'"
          [emptyText]="'workflow.empty_text' | translate"
          [buttonText]="
            canWriteWorkflows ? ('createNew' | translate) : undefined
          "
          (btnClick)="new()"
        >
        </app-empty-table>
      </app-datatable>

      <app-error [error]="error"></app-error>

      <app-model-modal #EditModal (saveEvent)="onSave()">
        <app-workflow-form
          #form
          (closeEvent)="onModalClose()"
          (loadingEvent)="onLoading($event.valueOf())"
        ></app-workflow-form>
      </app-model-modal>
    </div>
  </div>
</div>

<ng-template #definitionQuestionModal>
  <div class="modal-header">
    @if (selectedWorkflow) {
      <h4 class="modal-title">{{ selectedWorkflow.name }}</h4>
    }
    <button
      type="button"
      class="btn-close"
      (click)="modalRef?.close()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    <p>{{ 'workflow.edit-definition-question' | translate }}</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modalRef?.close()"
    >
      {{ 'cancel' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-warning"
      (click)="this.showDefinition()"
    >
      {{ 'edit' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #activateQuestionModal>
  <div class="modal-header">
    @if (selectedWorkflow) {
      <h4 class="modal-title">{{ selectedWorkflow.name }}</h4>
    }
    <button
      type="button"
      class="btn-close"
      (click)="modalRef?.close()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    @if (isActive(selectedWorkflow)) {
      <p>{{ 'workflow.deactivate-question' | translate }}</p>
    } @else {
      <p>{{ 'workflow.activate-question' | translate }}</p>
    }
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modalRef?.close()"
    >
      {{ 'cancel' | translate }}
    </button>
    @if (isActive(selectedWorkflow)) {
      <button
        type="button"
        class="btn btn-danger"
        (click)="toggleWorkflowStatus()"
      >
        {{ 'workflow.deactivate' | translate }}
      </button>
    } @else {
      <button
        type="button"
        class="btn btn-success"
        (click)="toggleWorkflowStatus()"
      >
        {{ 'workflow.activate' | translate }}
      </button>
    }
  </div>
</ng-template>

<ng-template #errorDeleteModal>
  <div class="modal-header">
    <h4 class="modal-title">{{ 'httperror.409' | translate }}</h4>
    <button
      type="button"
      class="btn-close"
      (click)="modalRef?.close()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    <p>{{ 'error.WorkflowAssignedToWorkers' | translate }}</p>
    <ul>
      @for (name of getDeleteWorkers(); track $index) {
        <li>{{ name }}</li>
      }
    </ul>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modalRef?.close()"
    >
      {{ 'OK' | translate }}
    </button>
  </div>
</ng-template>
